/* eslint-disable no-shadow */
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import '../index.scss';

import {
  getAllTemplatesBot,
  deleteTemplateBot,
} from '../../../store/actions/template-bot';
import NewBotTemplateCard from './NewBotTemplateCard';
import NewBotLearnMoreModal from './NewBotLearnMoreModal';
import TemplateBotModal from '../../../components/TemplateBotModal/index';

const NewBotTemplateList = (props) => {
  const { user, originalTemplateBots, setOriginalTemplateBots, chatRef } =
    props;
  const [showLearnMoreModal, setShowLearnMoreModal] = useState(false);
  const [showEditTemplateModal, setShowEditTemplateModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [learnMoreData, setLearnMoreData] = useState({});

  useEffect(() => {
    if (!_.isEmpty(learnMoreData)) {
      setShowLearnMoreModal(true);
    }
  }, [learnMoreData]);

  const onClickManagerTemplatesButton = (event) => {
    event.preventDefault();
    setIsEditMode(true);
  };

  const onClickSaveTemplatesListButton = (event) => {
    event.preventDefault();
    const { templatesBot, deleteTemplateBot, getAllTemplatesBot } = props;
    const deletedTemplatesIds = templatesBot
      .filter((template) => originalTemplateBots.indexOf(template) === -1)
      .map((template) => ({
        templateId: template._id,
      }));
    deleteTemplateBot(deletedTemplatesIds);

    getAllTemplatesBot();
    setIsEditMode(false);
  };

  const renderManagerTemplatesButton = () => {
    if (user?.selectedCompany?.claim?.name !== 'Root') {
      return false;
    }
    const onClickHandle = isEditMode
      ? onClickSaveTemplatesListButton
      : onClickManagerTemplatesButton;

    return (
      <button
        type="button"
        className="new-bot-template-list-manager-button"
        onClick={(event) => onClickHandle(event)}
      >
        <label>{isEditMode ? 'Salvar' : 'Gerenciar'}</label>
      </button>
    );
  };

  const renderTemplatesCards = () => {
    const { currentTemplateList } = props;
    if (currentTemplateList.length === 0) {
      return false;
    }

    return currentTemplateList.map((template) => {
      const { _id: id } = template;
      return (
        <NewBotTemplateCard
          key={id}
          showLearnMoreModal={showLearnMoreModal}
          setShowEditTemplateModal={setShowEditTemplateModal}
          isEditMode={isEditMode}
          template={template}
          setLearnMoreData={setLearnMoreData}
          originalTemplateBots={originalTemplateBots}
          setOriginalTemplateBots={setOriginalTemplateBots}
          chatRef={chatRef}
        />
      );
    });
  };

  return (
    <Fragment>
      <label className="new-bot-template-list-label">Templates</label>
      {renderManagerTemplatesButton()}
      <div className="new-bot-content-list">{renderTemplatesCards()}</div>
      <NewBotLearnMoreModal
        show={showLearnMoreModal}
        setShow={setShowLearnMoreModal}
        template={learnMoreData}
        setLearnMoreData={setLearnMoreData}
      />
      <TemplateBotModal
        show={showEditTemplateModal}
        setShow={setShowEditTemplateModal}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    templatesBot: state.templateBot.allTemplateBots,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { deleteTemplateBot, getAllTemplatesBot },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewBotTemplateList);
